import { render, staticRenderFns } from "./CardEnvironmentalRestrictions.vue?vue&type=template&id=0ec42726&scoped=true"
import script from "./CardEnvironmentalRestrictions.vue?vue&type=script&lang=js"
export * from "./CardEnvironmentalRestrictions.vue?vue&type=script&lang=js"
import style0 from "./CardEnvironmentalRestrictions.vue?vue&type=style&index=0&id=0ec42726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec42726",
  null
  
)

export default component.exports